import axios from "axios"

export function getBlacklistedAdCategories(token, userId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getBlacklistedAdCategories?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}
